
import React, { useState } from 'react';
import { StepProps } from '../props/StepProps';
import { Button, Col, Row } from 'antd';


interface ButtonProps {
    prev?: () => void;
    next?: () => void;
}

export const ButtonList = ({
    prev,
    next,
}: ButtonProps) => {

    return (
        <>
            <Row justify="center" className='w-full mb-6'>
                <Col span={12} style={{ paddingRight: '8px' }}>
                    <Button
                        size='large'
                        className='button-container previous'
                        onClick={() => prev && prev()}
                    >
                        戻る
                    </Button>
                </Col>
                <Col span={12} style={{ paddingLeft: '8px' }}>
                    <Button type="primary" size='large'
                        onClick={() => next && next()}
                        className='button-container'>
                        送信する
                    </Button>
                </Col>
            </Row>
        </>
    );

}